module.exports = __webpack_public_path__ + "static/media/design10.0022ef47.png";